var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7049 10L12.2949 11.41L16.8749 16L12.2949 20.59L13.7049 22L19.7049 16L13.7049 10Z",
    fill: "#4555D6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#6A7F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWithBg);
export default __webpack_public_path__ + "static/media/arrow-with-bg.d6bf1eab2267d57143e3e8d1b8c6851f.svg";
export { ForwardRef as ReactComponent };